import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于内裤选购与保养的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => toggleFaq(index)}
                aria-expanded={openIndex === index}
              >
                <span className="font-medium text-foreground-900 text-sm md:text-base pr-4">
                  {faq.question}
                </span>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                  <i
                    className={`text-primary-500 transition-transform duration-300 ${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <div className="px-5 text-foreground-600 text-sm leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}